
import { mapState, mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { DEFAULT_NAME, DEFAULT_CODE } from '@/constants/'
import api from '~/api/'
import SearchPeriodCorp from '~/components/Common/UI/Search/SearchPeriodCorp'
import ResearchPaging from '~/components/Research/ResearchPaging'

export default {
    components: {
        ResearchPaging,
        SearchPeriodCorp,
    },
    data() {
        return {
            curPage: 1, // 현재페이지
            countByPage: 25, // 한페이지당 갯수
            startDate: null, // params.startDate
            endDate: null, // params.endDate
            stockCode: null, // params.stockCode
            stockName: null,
            stockNewsType: [], // 구분검색 options
            newsType: { name: '전체', value: null }, // 구분 초기값
            stockHis: {
                totalCount: 0,
                items: [],
            },
            loadingStatus: true,
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch', 'stockHistoryType']),
        ...mapState({
            stockHistoryType: (state) => state.search.StockHistoryType,
            searchDate: (state) => state.search.date,
        }),

        // 전체 글의 수
        setTotalCount() {
            let count = 0
            if (this.stockHis.items != null && this.stockHis.items.length > 0) {
                count = this.stockHis.totalCount
            }
            return count
        },
    },
    watch: {
        // 날짜 선택 시 data 값 넣어줌
        searchDate(val) {
            this.startDate = val.startDate
            this.endDate = val.endDate
        },
    },
    created() {
        this.initParams()
        this.getNewsTypeList() // 구분 options

        /* 
            220608 meej 초기 값 수정 : 종목(삼성전자), 기간(7일)
         */
        // 초기 종목 : 삼성전자
        this.stockCode=DEFAULT_CODE
        this.stockName=DEFAULT_NAME
    
        // 초기값 : 7일
        this.startDate = dayjs(new Date()).subtract(7,'days').format('YYYY-MM-DD')
        this.endDate = dayjs(new Date()).format('YYYY-MM-DD')

        this.getListData()
    },
    methods: {
        ...mapActions('search', ['GET_CORP_INFO']),
        ...mapActions('search', ['GET_NEWSTYPE_LIST']),

        formatDate(val) {
            if (val !== null && val !== '') {
                return val.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
            }
            return ''
        },
        // date format 제거
        delFormatDate(val) {
            if (val !== null && val !== '' && val.includes('-')) {
                return val.replaceAll('-', '')
            }
            return val
        },
        /* 구분 options  */
        getNewsTypeList() {
            const params = {
                newsType: 'StockHistoryType',
            }

            this.GET_NEWSTYPE_LIST(params).then(() => {
                this.stockNewsType = [{ name: '전체', value: '000' }]
                this.stockNewsType.push(...this.stockHistoryType)
            })
        },
        // 종목 클릭시 종목정보 팝업
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
        // params 초기화
        initParams() {
            this.startDate = null
            this.endDate = null
            this.stockCode = null
            this.curPage = 1
            this.countByPage = 25
        },
        // 페이징 c초기화
        initPageParams() {
            this.curPage = 1
            this.countByPage = 25
        },
        // 페이지 번호 클릭시
        onClickPage(page) {
            this.curPage = page
            this.getListData()
        },
        async getListData() {
            this.loadingStatus = true
            const params = {
                pageNo: this.curPage,
                countByPage: this.countByPage,
                code: this.stockCode,
                startDate: this.delFormatDate(this.startDate),
                endDate: this.delFormatDate(this.endDate),
                newsType: this.newsType.value,
            }

            await api.getStockHistory(params).then((res) => {
                this.stockHis.items = res.data.issues
                this.dataProcessing(this.stockHis)
                this.stockHis.totalCount = res.data.totalCount
                this.loadingStatus = false
            })
        },
        // 데이터 가공
        dataProcessing(data) {
            for (let i = 0; i < data.items.length; i++) {
                if (
                    data.items[i].content !== null &&
                    data.items[i].content !== ''
                ) {
                    data.items[i].content = data.items[i].content
                        .replaceAll('\n', '<br>')
                        .replaceAll('<br><br>', '<br>')
                }
                // status 에 따라 newsType1 설정 및 content 변경
                switch (data.items[i].newsType1) {
                    case 'STOCK_COMPANY_OPINION':
                        data.items[i].newsType1 = '투자의견'
                        if (
                            data.items[i].content === null ||
                            data.items[i].content === ''
                        ) {
                            data.items[i].content =
                                data.items[i].stockCompanyName +
                                ' | 투자의견 : ' +
                                data.items[i].OPINION0 +
                                '/' +
                                (data.items[i].PRICE * 1).toLocaleString(
                                    'ko-KR'
                                )
                        } else {
                            data.items[i].content =
                                data.items[i].stockCompanyName +
                                ' | ' +
                                data.items[i].content
                        }
                        break
                    case 'STOCK_ISSUE':
                        data.items[i].newsType1 = '종목이슈'
                        break
                    case 'STOCK_NEW_RECOMMEND':
                        data.items[i].newsType1 = '신규추천'
                        /* 220603 meej 조건문 추가 */
                        if(data.items[i].stockCompanyName !== undefined 
                            && data.items[i].RECOMMEND_TYPE !== undefined){
                            data.items[i].content =
                                data.items[i].stockCompanyName +
                                ' (' +
                                data.items[i].RECOMMEND_TYPE +
                                ') <br>' +
                                data.items[i].content
                            }
                        if (data.items[i].EXCLUSION0 === '1') {
                            data.items[i].content +=
                                "<br><span style='color:grey'>"
                            if (
                                data.items[i].EXCLUDED_DATE0 !== null &&
                                data.items[i].EXCLUDED_DATE0 !== ''
                            ) {
                                const YYYY = data.items[
                                    i
                                ].EXCLUDED_DATE0.substring(0, 4)
                                const MM = data.items[
                                    i
                                ].EXCLUDED_DATE0.substring(4, 6)
                                const DD = data.items[
                                    i
                                ].EXCLUDED_DATE0.substring(6, 8)
                                data.items[i].EXCLUDED_DATE0 =
                                    YYYY + '-' + MM + '-' + DD
                                data.items[i].content +=
                                    data.items[i].EXCLUDED_DATE0
                            }
                            if (
                                data.items[i].CAUSE !== null &&
                                data.items[i].CAUSE !== ''
                            ) {
                                data.items[i].content +=
                                    ' ' + data.items[i].CAUSE
                            }
                            data.items[i].content += '</span>'
                        }
                        break
                    case 'STOCK_DISCLOSURE':
                        data.items[i].newsType1 = '공시'
                        break
                    case 'STOCK_52_WEEKS_NEW_HIGH':
                        data.items[i].newsType1 = '종목이슈'
                        if (
                            data.items[i].content !== '' &&
                            data.items[i].content !== null
                        ) {
                            data.items[i].content =
                                '52주 신고가 - ' + data.items[i].content
                        } else {
                            data.items[i].content = '52주 신고가'
                        }
                        break
                    case 'STOCK_JUMP':
                        data.items[i].newsType1 = '종목이슈'
                        /* 220603 meej 조건문 추가 */
                        if (data.items[i].DAYS > 0) {
                            data.items[i].content =
                                '상한가 - ' +
                                data.items[i].content +
                                ' - ' +
                                data.items[i].DAYS +
                                '일 연속'
                        }else{
                            data.items[i].content =
                                '급등 - ' +
                                data.items[i].content
                        }
                        break
                    case 'STOCK_SLUMP':
                        data.items[i].newsType1 = '종목이슈'
                        /* 220603 meej 조건문 추가 */
                        if (data.items[i].DAYS > 0) {
                            data.items[i].content =
                                '하한가 - ' +
                                data.items[i].content +
                                ' - ' +
                                data.items[i].DAYS +
                                '일 연속'
                        }else{
                            data.items[i].content =
                                '급락 - ' +
                                data.items[i].content 
                        }
                        break
                    case 'STOCK_FEATURED':
                        data.items[i].newsType1 = '종목이슈'
                        break
                    case 'STOCK_STRONG_BUY':
                        data.items[i].newsType1 = '종목이슈'
                        data.items[i].content =
                            data.items[i].stockCompanyName +
                            '  강력매수<br>' +
                            data.items[i].content
                        break
                    case 'THEME_HISTORY':
                        data.items[i].newsType1 = '테마'
                        data.items[i].content =
                            "<span style='font-weight:500'>[ "+data.items[i].themeName +' ] </span><br>'+
                            data.items[i].content
                        break
                }

                // yyyy-mm-dd 으로 보이게 변경
                data.items[i].showDate = this.formatDate(data.items[i].showDate)
            }
        },
        // 종목검색
        getCorpSearch(value, name) {
            this.stockCode = value
            this.stockName = name
        },
        // 검색버튼
        goSearch() {
            this.initPageParams()
            this.getListData()
        },
        // 구분 선택
        getSelecteType(val) {
            this.newsType = val
        },
        // 조회조건 delete
        delteValue(val) {
            if (val === 'newsType') {
                this.newsType = {}
            } else if (val === 'stockCode') {
                this.stockCode = null
            } else if (val === 'startDate') {
                this.startDate = null
            } else if (val === 'endDate') {
                this.endDate = null
            }
        },
    },
}
